import { Record } from 'immutable';

const defaultValues = {
  loading: false,
  errorMessage: null,
  editor: null,
  userInfo: null,
};

export default class Editor extends Record(defaultValues, Editor) {
  constructor(values) {
    super({
      ...values,
    });
  }
}
